import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { OVARIAN } from "../../../../constants";


export default function FertilityAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={OVARIAN}
        title="OVARIAN RESERVE FEMALE"
        subtitle="Provides a detailed assessment of ovarian egg reserve, reflecting the remaining number of eggs and offering insight into ovarian function and reproductive potential over time"
        markersTitle=" 49,- incl. VAT"
        markers="Anti-Müllerian Hormone (AMH)"
    />


)
}